import React from 'react'

import { connect } from 'react-redux'

import Select from 'components/Select'

import BasePureComponent from 'utils/BasePureComponent'
import request from 'utils/request'

import { STATES_URL, CITIES_URL } from 'constants'
import { fetchOnFilter } from 'scenes/Clients/actions'

import './style.scss'


export class LocationFilter extends BasePureComponent {
  constructor(props) {
    super(props);

    this.state = {
      states: [],
      cities: []
    }

    this._bind('_fetchStates', '_onStateChange', '_onCityChange')
  }

  componentDidMount() {
    this._fetchStates()
  }

  _convertToOption(item) {
    return { value: item.id, label: item.name }
  }

  _fetchStates() {
    request(STATES_URL)
    .then((response) => {
      const states = response.states.map(this._convertToOption)
      this.setState({ states })
    })
    .catch((err) => console.log(err))
  }

  _onStateChange(selectedOption) {
    const stateID = !!selectedOption ? selectedOption.value : null

    this.props.filterChanged(stateID, null)
    request(CITIES_URL(stateID))
    .then((response) => {
      const cities = response.cities.map(this._convertToOption)
      this.setState({ cities })
    })
    .catch((err) => console.log(err))
  }

  _onCityChange(selectedOption) {
    const cityID = !!selectedOption ? selectedOption.value : null
    this.props.filterChanged(this.props.filter.state, cityID)
  }

  render() {
    return (
      <section className="LocationFilter">
        <h6>FILTROS</h6>
        <div className="LocationFilter__box">
          <div className="LocationFilter__box-header">
            <span>Ubicación</span>
          </div>
          <div className="LocationFilter__box-body">
            <Select
              label="Estado"
              placeholder="Estado"
              options={this.state.states}
              onChange={this._onStateChange}
              value={this.props.filter.state}
            />
            <Select
              label="Ciudad"
              placeholder="Ciudades"
              options={this.state.cities}
              onChange={this._onCityChange}
              value={this.props.filter.city}
            />
          </div>
        </div>
      </section>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    filter: state.clients.get('filter').toJS()
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    filterChanged: (state, city) => dispatch(fetchOnFilter(state, city))
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(LocationFilter)



// WEBPACK FOOTER //
// ./src/scenes/Clients/components/LocationFilter/index.js